// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"182":"e8bb488a","692":"6f6c8570","893":"e8bb488a"}[chunkId] + ".chunk.css";
};